import { render, staticRenderFns } from "./WorkItemList.vue?vue&type=template&id=7ce3e530&scoped=true"
import script from "./WorkItemList.vue?vue&type=script&lang=js"
export * from "./WorkItemList.vue?vue&type=script&lang=js"
import style0 from "./WorkItemList.vue?vue&type=style&index=0&id=7ce3e530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce3e530",
  null
  
)

export default component.exports